import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessengerService } from '@services/messenger/messenger.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  email: string;
  password: string = null;

  constructor(private router: Router, private route: ActivatedRoute, private ms: MessengerService, private snackbar: SnackbarService) {
  }

  ngOnInit() {
  }

  navigateToLogin() {
    this.router.navigate([{ outlets: { 'authentication': ['login'] } }], { relativeTo: this.route.parent });
  }

  validateEmail() {
    return /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.email);
  }

  onPasswordValidatiton(password) {
    this.password = password;
  }

  register() {
    this.ms.createEmailPasswordCredential(this.email, this.password).then(result => {
      this.snackbar.success('Account created');
    }, err => {
      console.log(err);
      this.snackbar.error('Could not register new account');
    });
  }

}
